var EqOwner = {
  INTERNAL_EHPAD: 0,
  DM_FROM_PSDM: 1,
  EXTERNAL: 2,
  PRIVATE_INDIVIDUAL: 3,
};

module.exports = EqOwner;
